import styled from 'styled-components';
import { device } from 'modules/Utils/Devices';

export const FormContainer = styled.div`
  display: grid;
  grid-gap: 0 2.4rem;
  grid-template-columns: 1fr 1fr;

  @media ${device.mobile} {
    grid-template-columns: 1fr;
  }
`;
